import type { ISerialize } from '@/objects/ISerialize';
import type { SetSeedingGroupType } from './../enums/SetSeedingGroupType';

export class SetSeedingGroupRequest implements ISerialize {
    public categoryIDs: number[];

    public NmABC: number | null;

    public NmABCD: number | null;

    public ResetAllCategories: boolean;

    public SetGroupSize: number | null;

    public SetSeedingGroupType: SetSeedingGroupType;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        categoryIDs?: number[];
        NmABC?: number | null;
        NmABCD?: number | null;
        ResetAllCategories?: boolean;
        SetGroupSize?: number | null;
        SetSeedingGroupType?: SetSeedingGroupType;
    }) {
        this.categoryIDs = values.categoryIDs ?? [];

        this.NmABC = values.NmABC ?? null;

        this.NmABCD = values.NmABCD ?? null;

        this.ResetAllCategories = values.ResetAllCategories ?? false;

        this.SetGroupSize = values.SetGroupSize ?? null;

        this.SetSeedingGroupType = values.SetSeedingGroupType ?? 'Random';
    }

    public serialize(): string {
        return (
            '{' +
            `"categoryIDs": [ ${this.categoryIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"NmABC": ${JSON.stringify(this.NmABC)}` +
            ',' +
            `"NmABCD": ${JSON.stringify(this.NmABCD)}` +
            ',' +
            `"ResetAllCategories": ${JSON.stringify(this.ResetAllCategories)}` +
            ',' +
            `"SetGroupSize": ${JSON.stringify(this.SetGroupSize)}` +
            ',' +
            `"SetSeedingGroupType": ${this.SetSeedingGroupType == 'Random' ? 0 : this.SetSeedingGroupType == 'ScandinavianCup' ? 1 : this.SetSeedingGroupType == 'NmABC' ? 2 : this.SetSeedingGroupType == 'NmABCD' ? 3 : this.SetSeedingGroupType == 'SetGroupSize' ? 4 : 0}` +
            '}'
        );
    }

    /**
     * Creates an instance of SetSeedingGroupRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        categoryIDs?: number[];
        NmABC?: number | null;
        NmABCD?: number | null;
        ResetAllCategories?: boolean;
        SetGroupSize?: number | null;
        SetSeedingGroupType?: SetSeedingGroupType;
    }): SetSeedingGroupRequest {
        return new SetSeedingGroupRequest(values);
    }

    public static _FromServerJson(json: any): SetSeedingGroupRequest {
        return new SetSeedingGroupRequest({
            categoryIDs: json.categoryIDs,
            NmABC: json.NmABC ?? null,
            NmABCD: json.NmABCD ?? null,
            ResetAllCategories: json.ResetAllCategories,
            SetGroupSize: json.SetGroupSize ?? null,
            SetSeedingGroupType:
                json.SetSeedingGroupType == 0
                    ? 'Random'
                    : json.SetSeedingGroupType == 1
                      ? 'ScandinavianCup'
                      : json.SetSeedingGroupType == 2
                        ? 'NmABC'
                        : json.SetSeedingGroupType == 3
                          ? 'NmABCD'
                          : json.SetSeedingGroupType == 4
                            ? 'SetGroupSize'
                            : 'Random',
        });
    }

    /**
     * Creates an instance of SetSeedingGroupRequest from another instance of SetSeedingGroupRequest.
     * @param other The SetSeedingGroupRequest you want to clone
     * @returns A cloned SetSeedingGroupRequest
     */
    public static FromOther(other: SetSeedingGroupRequest): SetSeedingGroupRequest {
        return SetSeedingGroupRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SetSeedingGroupRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SetSeedingGroupRequest';
}
